import '@hkdevs/design-system/styles.css';
// The brand pack's stylesheet is linked from index.html, one pack per deployment
// (brandPacks.ts).
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApiProvider } from './api/ApiProvider';
import { createApiClient } from './api/client';
import { createQueryClient } from './api/queryClient';
import { startErrorTracking } from './observability/errorTracking';
import { createAppRouter } from './router';
import { loadDeploymentPack } from './theme/brand';

startErrorTracking();

const root = document.getElementById('root');
if (!root) throw new Error('The #root element is missing from index.html');

// The pack in <html data-brand>. A missing or unknown one stops the app here, loudly.
const brandPack = await loadDeploymentPack().catch((error: unknown) => {
  root.textContent = 'This deployment is misconfigured: its brand pack is unknown.';
  throw error;
});

const queryClient = createQueryClient();
// A 401 anywhere means the session ended: go to Login without a full reload.
const api = createApiClient({ onUnauthenticated: () => goToLogin() });
const router = createAppRouter({
  queryClient,
  api,
  openExternal: (url) => window.location.assign(url),
  brandPack,
});

function goToLogin() {
  if (router.state.location.pathname !== '/login') void router.navigate({ to: '/login' });
}

createRoot(root).render(
  <StrictMode>
    <ApiProvider client={api} queryClient={queryClient}>
      <RouterProvider router={router} />
    </ApiProvider>
  </StrictMode>,
);
